import { GroupSecurity } from '@quromedical/fhir-common';
import { withPermissions } from 'components/groups';
import { PathologyScreen } from 'screens/patient';

export default withPermissions(PathologyScreen, [
  GroupSecurity.ServiceRequestRead,
]);
